<div class="select-area">
    <div class="input-area">
        <dx-text-box #alanKodBox
            class="code-area"
            [readOnly]="isReadOnly"
            placeholder="+90(___)"
            [label]="labelMode === 'outside'?'':(isTel?(isTel?'Alan Kodu':'Fax Alan Kod'):'')"
            [labelMode]="labelMode"
            (onValueChanged)="inputChange($event,'alan')"
            [value]="alanKodu | alanKodValuePipe"
            [mask]="isTel?'+\\9\\0 (000)':'+\\0 (000)'"
            (onInput)="alanOnInput($event)"
            (onKeyDown)="alanKeyDown($event)"
            (onCopy)="tamNumaraKopyala($event)"
            >
            
    </dx-text-box>
    <dx-text-box #telefonBox
    class="tel-area"
    [ngClass]="{
        'tel-area-with-btn' : showGetDataBtn && !isReadOnly
            }"
            placeholder="___-____"
            [label]="labelText?(labelText?labelText:isTel?'Telefon':'Fax Telefon'):''"
            [labelMode]="labelMode"
            (onValueChanged)="inputChange($event,'telefon')"
            [readOnly]="isReadOnly"
            [value]="telefon"
            [mask]="'000-0000'"
            (onKeyDown)="telefonKeyDown($event)"
            (onCopy)="tamNumaraKopyala($event)"
            >
        <dxi-button
          *ngIf="showGetDataBtn && !isReadOnly"
          location="after"
          name="showGetDataBtn"
          [options]="showGetDataBtnOptions"
          [tabindex]="-1"
        >
        </dxi-button>
    </dx-text-box>
    

    </div>
</div>

